import { Checkbox, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommExAppControlMessage extends Layout {
    checkboxAddAccident: Checkbox;
    checkboxAutoConfirm: Checkbox;
    checkboxDirectedMessagesByLoginId: Checkbox;
    checkboxDirectedMessagesByPhoneExt: Checkbox;
    checkboxSendEmail: Checkbox;
    panelMessageSection: Panel;
    panelOne: Panel;
    panelTwo: Panel;
    sourceMCExAppControl: DataSource;
    textboxEmailAddress: Textbox;
    textboxLoginIdField: Textbox;
    textboxPhoneExtensionField: Textbox;
}
